/**
 * Flush Promise: a useful alternative to nextTick
 * @returns Promise
 */
 const flushQueue = () => {
    return new Promise((resolve) => setTimeout(resolve, 0));
}

export default flushQueue;